export const insuranceNumberExists = (state) =>
  (state.entities.users.error?.insurance_number || []).includes(
    'Bitte verwende die E-Mail-Adresse, die du für deine Krankenkassen-Kooperation hier verwendest.'
  );
